<template>
  <div class="app bg-gray" id="register-dateTimeSchedule">
    <!-- 医生信息 -->
    <section class="doctor-info thick">
      <div
        class="head doc-header"
        v-bind:style="{
          backgroundImage:
            'url(' +
            (registInfo.doc.doctAvatar
              ? registInfo.doc.doctAvatar
              : '../../../static/img/ico-doctor.png') +
            ')',
        }"
      ></div>
      <div class="info">
        <p class="f-large f-normal ellipsis">
          {{ registInfo.doc.doctLevel }} {{ registInfo.doc.doctName }}
        </p>
        <p class="f-small f-minor ellipsis">{{ registInfo.doc.deptName }}</p>
      </div>
    </section>
    <!-- tab标签 -->
    <!--<section class="thick">-->
    <!--<ul class="tab-top">-->
    <!--<li @click="onSelectedTab(item)" v-for="item in tabs" class="tab-item" :id="'register-departDoctor-tab-'+item.tabId"-->
    <!--:class="{ 'active': selectedTab.tabId == item.tabId }">-->
    <!--<span class="tab-label">{{item.tabName}}</span>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</section>-->
    <section>
      <!-- 时间选择 -->
      <time-table
        @change="loadDocSchedules"
        :areaId="registInfo.area.areaId"
        :deptId="registInfo.doc.deptId"
      ></time-table>
      <!-- 时段列表 -->
      <scroll @refresh="loadDocSchedules" style="top: 6.4rem">
        <no-record
          :condition="docSchedules"
          tips="没有找到该医生排班信息"
          id="register-dateTimeSchedule-norecord"
        ></no-record>
        <section v-for="docScheduleItem in docSchedules" class="thick">
          <!-- 门诊类型 -->
          <div class="panel">
            <span class="f-strong">{{ docScheduleItem.typeName }}门诊</span
            ><span class="pull-right f-strongest">{{
              docScheduleItem.fee | formatFee
            }}</span>
          </div>
          <!-- 实时排班 -->
          <ul class="list">
            <li
              v-for="(schedule, index) in timeSchedules[docScheduleItem.typeId]"
              class="list-item"
              :class="{ 'arr-item-blue': schedule.status === 1 }"
              @click="onSelected(schedule)"
              :id="'register-dateTimeSchedule-list-' + index"
            >
              <span>{{ schedule.timeslot }}</span>
              <span v-if="schedule.status === 1" class="pull-right f-strong"
                >预约</span
              >
              <span
                v-if="schedule.status === 2"
                class="pull-right f-minor"
                style="padding-right: 0.79rem"
                >满诊</span
              >
              <span
                v-if="schedule.status === 3"
                class="pull-right f-identify"
                style="padding-right: 0.79rem"
                >停诊</span
              >
            </li>
          </ul>
        </section>
      </scroll>
    </section>
    <!--<div class="doct-desc row" v-if="selectedTab.tabId === 1">-->
    <!--{{doctDesc ? doctDesc : "暂无医生介绍"}}-->
    <!--</div>-->
  </div>
</template>

<script>
import TimeTable from 'TimeTable';
import NoRecord from 'NoRecord';
import registerService from 'register.service'
export default {
  components: {
    TimeTable,
    NoRecord
  },
  data () {
    var params = this.$store.state.paramModule.param.register;
    return {
      // tabs: [{'tabId': 0, 'tabName': '门诊排班', 'searchText': '输入二级科室', 'noRecordText':'查找不到科室，请重新输入'},
      //     {'tabId': 1, 'tabName': '医生介绍', 'searchText': '输入医生姓名', 'noRecordText':'查找不到医生，请重新输入'}],
      // selectedTab: {'tabId': 0, 'tabName': '门诊排班'},
      registInfo: params,
      hospitalName: JSON.parse(localStorage.selectedHospital).hospitalName || "",
      // 医生排班信息
      docSchedules: [],
      timeSchedules: {},
      // doctDesc:this.$store.state.paramModule.param.register.doc.doctDesc,
    }
  },
  methods: {
    loadDocSchedules: function () {
      this.docSchedules = this.constant.ARRAY_CLEAN;
      this.timeSchedules = {};
      /* 获取该医生名下的排班信息，找出门诊类型和费用 */
      var doctorScheduleParams = {
        areaId: this.registInfo.area.areaId,
        deptId: this.registInfo.doc.deptId,
        regDate: this.registInfo.date.value,
        doctId: this.registInfo.doc.doctId
      }
      registerService.loadDoctorSchedule(doctorScheduleParams).then((res) => {
        if (this.registInfo.date.value !== doctorScheduleParams.regDate) {
          return;
        }
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        this.docSchedules = res.data || [];
        // 获取到该医生当天的排班类型
        this.docSchedules.forEach((item) => {
          // 轮流查询出该医生专家门诊和普通门诊下面的实时排班
          this.loadTimeSchedules(item);
        });
      })
    },
    loadTimeSchedules: function (doctorScheduleItem) {
      /* 获取该医生指定门诊类型下的实时排班 */
      var timeScheduleParams = {
        areaId: this.registInfo.area.areaId,
        deptId: this.registInfo.doc.deptId,
        regDate: this.registInfo.date.value,
        doctId: this.registInfo.doc.doctId,
        rankId: doctorScheduleItem.rankId,
        typeId: doctorScheduleItem.typeId,
        typeName: doctorScheduleItem.typeName
      }
      registerService.loadTimeSchedules(timeScheduleParams).then((res) => {
        if (this.registInfo.date.value !== timeScheduleParams.regDate) {
          return;
        }
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        this.timeSchedules = {};
        var typeId = timeScheduleParams.typeId;
        var typeName = timeScheduleParams.typeName;
        var deptId = this.registInfo.doc.deptId;
        var deptName = this.registInfo.doc.deptName;
        var schedules = res.data ? this.transTimeSlots(res.data, typeId, typeName, deptId, deptName) : [];
        this.timeSchedules[typeId] = schedules;
      })
    },
    transTimeSlots: function (timeSchedule, typeId, typeName, deptId, deptName) {
      var slots = timeSchedule.timeTablesList;
      if (!slots) {
        return [];
      }
      function buildSlot (item) {
        return {
          deptId: deptId,
          deptName: deptName,
          typeId: typeId,
          typeName: typeName,
          doctId: timeSchedule.doctId,
          doctName: timeSchedule.doctName,
          rankId: timeSchedule.rankId,
          rankName: timeSchedule.rankName,
          timeslot: item.startTime.substring(0, 5) + "-" + item.endTime.substring(0, 5),
          startTime: item.startTime,
          endTime: item.endTime,
          status: item.status,
          phaseId: item.phaseId,
          regSourceId: item.regSourceId,
          fee: item.fee,
          ordNum: item.ordNum
        };
      }
      var schedules = [];
      slots.forEach(function (item) {
        var slot = buildSlot(item);
        schedules.push(slot);
      });
      return schedules;
    },

    onSelected: function (schedule) {
      if (!this.isRegisterStatus(schedule.status)) {
        return;
      }
      this.$store.commit('updateParam', {
        namespace: 'register',
        schedule: schedule
      })
      this.$router.push({
        name: 'registConfirm'
      });
    },
    isRegisterStatus: function (status) {
      return status === 1;
    },
    // onSelectedTab: function(item) {
    //     this.selectedTab = item;
    // },
  }
}
</script>

<style lang="scss" >
@import "../../../static/sass/_variable.scss";
.doct-desc {
  margin-top: -5px;
  overflow-y: auto;
  word-break: break-all;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// DateTimeSchedule.vue?10db6b28